'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _iconButton = require('./icon-button');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_iconButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }